import { render, staticRenderFns } from "./ShareTwitterComponent.vue?vue&type=template&id=2cbb843c&scoped=true"
import script from "./ShareTwitterComponent.vue?vue&type=script&lang=js"
export * from "./ShareTwitterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb843c",
  null
  
)

export default component.exports